const WS_PATH = '/ws'

export type SttFinalMessage = {
  type: 'final'
  text: string
  segment_id: number
}
export type SttCorrectedMessage = {
  type: 'corrected'
  text: string
  segment_id: number
  done: boolean
}

export function createSttWebSocketUrl(
  baseUrl: string,
  opts: { language?: string; targetLanguage?: string }
): string {
  const normalized = baseUrl.replace(/\/$/, '').replace(/^http/, 'ws')
  const url = new URL(WS_PATH, normalized + '/')
  if (opts.language) url.searchParams.set('language', opts.language)
  if (opts.targetLanguage)
    url.searchParams.set('target_language', opts.targetLanguage)
  return url.toString()
}

export function safeJsonParse(raw: string): unknown {
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function isFinalMessage(msg: unknown): msg is SttFinalMessage {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    (msg as Record<string, unknown>).type === 'final' &&
    typeof (msg as Record<string, unknown>).text === 'string' &&
    typeof (msg as Record<string, unknown>).segment_id === 'number'
  )
}

export function isCorrectedMessage(msg: unknown): msg is SttCorrectedMessage {
  return (
    typeof msg === 'object' &&
    msg !== null &&
    (msg as Record<string, unknown>).type === 'corrected' &&
    typeof (msg as Record<string, unknown>).text === 'string' &&
    typeof (msg as Record<string, unknown>).segment_id === 'number' &&
    typeof (msg as Record<string, unknown>).done === 'boolean'
  )
}
